import {IDesignInfo, Project} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {BasePage} from '@mintdata-wsp/wsp/ui/pages/BasePage';
import {DesignsList} from '@mintdata-wsp/wsp/ui/views/workspace/home/designs/DesignsList';
import {DesignsFilterType} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsFilters';
import * as classnames from 'classnames/bind';
import {computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./SpacesPage.less');
const cx = classnames.bind(styles);

@observer
export class SpacesPage extends BasePage<RouteComponentProps<any>, any>
{
    @computed
    private get _project():Project
    {
        const {match} = this.props;
        const {projectId} = match.params;

        return controllers.ui.mainPage.getProjectById(projectId);
    }

    @computed
    private get _currentDesigns():Array<IDesignInfo>
    {
        const {allDesigns, getFilteredDesigns} = controllers.ui.mainPage;

        const project = this._project;

        if( !project ) return [];

        const currentDesigns = allDesigns.filter(({projectId}) => projectId == project.id);

        return getFilteredDesigns(currentDesigns, DesignsFilterType.Spaces);
    }

    componentDidMount()
    {
        controllers.ui.mainPage.setCurrentProject(this._project);
        // const {match} = this.props;
        //
        // const {projectId} = match.params;
        //
        // controllers.data.projects.syncAllProjects().then(() =>
        // {
        //     const project = rootState.data.projects.find((project:Project) => project.id == projectId);
        //
        //     console.log('%c project 1 =', 'background:#0f0;color:#000;', project);
        //
        //     if(!project) return;
        //
        //     controllers.data.designs.getDesignsForProject(project).then(() =>
        //     {
        //         const {currentDesigns} = rootState.ui.mainPage;
        //
        //         console.log('%c currentDesigns 1 =', 'background:#0f0;color:#000;', currentDesigns);
        //     });
        // });
    }

    componentDidUpdate(prevProps:Readonly<RouteComponentProps<any>>, prevState:Readonly<any>, prevContext:any):void
    {
        const {projectId} = this.props.match.params;
        const {projectId: prevProjectId} = prevProps.match.params;

        const {currentProject} = rootState.ui.mainPage;

        if( (!currentProject && this._project) || (projectId && prevProjectId && projectId !== prevProjectId) )
        {
            controllers.ui.mainPage.setCurrentProject(this._project);
        }
    }

    componentWillReceiveProps(nextProps:any):void
    {
        // const {match} = this.props;
        // const {match: nextMatch} = nextProps;
        //
        // const {projectId} = match.params;
        //
        // const project = rootState.data.projects.find((project:Project) => project.id == projectId);
        //
        // console.log('%c project 2 =', 'background:#0f0;color:#000;', project);
        //
        // if(!project) return;
        //
        // controllers.data.designs.getDesignsForProject(project).then(() =>
        // {
        //     const {currentDesigns} = rootState.ui.mainPage;
        //
        //     console.log('%c currentDesigns 2 =', 'background:#0f0;color:#000;', currentDesigns);
        // });
    }

    componentWillUnmount():void
    {
        controllers.ui.mainPage.setCurrentProject(null);
    }

    render()
    {
        const {match} = this.props;

        return (
            <Column className={cx(styles.page)}>

                <DesignsList
                    filterType={DesignsFilterType.Spaces}
                    designs={this._currentDesigns}
                    newDesign={true}
                    goToSpaceMenu={false}
                />

            </Column>
        );
    }

}
